import { useState, useEffect } from 'react';

export default function WhatIsVoxDaySection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const images = [
    {
      src: "/images/voxday/1.jpeg",
      alt: "Apresentação de aluno Vox2You"
    },
    {
      src: "/images/voxday/2.jpeg",
      alt: "Dinâmica em grupo Vox2You"
    },
    {
      src: "/images/voxday/3.jpeg",
      alt: "Exercício de oratória Vox2You"
    }
  ];

  const activities = [
    {
      icon: 'ri-mic-line',
      title: 'praticar comunicação ao vivo',
      description: 'Exercícios práticos em tempo real'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'experimentar técnicas de oratória',
      description: 'Metodologia comprovada da Vox2you'
    },
    {
      icon: 'ri-feedback-line',
      title: 'receber feedback profissional',
      description: 'Orientação personalizada de especialistas'
    },
    {
      icon: 'ri-user-star-line',
      title: 'desenvolver presença e confiança',
      description: 'Transforme sua postura e atitude'
    },
    {
      icon: 'ri-key-line',
      title: 'desbloquear sua forma de se expressar',
      description: 'Liberte seu potencial comunicativo'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            O que é o <span className="text-[#F19E1A]">VoxDay</span>?
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 font-semibold mb-3">
            Uma experiência prática de comunicação
          </p>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Durante <strong>4 horas intensas</strong>, você vai viver uma experiência imersiva baseada na metodologia Vox2you.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <div className="relative overflow-hidden rounded-2xl shadow-xl">
            <div 
              className="flex transition-transform duration-700 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {images.map((image, index) => (
                <div key={index} className="w-full flex-shrink-0">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-80 object-cover"
                  />
                </div>
              ))}
            </div>
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    index === currentSlide ? 'bg-[#F19E1A] w-8' : 'bg-white/70'
                  }`}
                />
              ))}
            </div>
          </div>

          <div className="bg-[#F19E1A] text-white rounded-2xl p-8 flex flex-col justify-center">
            <p className="text-2xl md:text-3xl font-bold mb-4">
              Você não vai ficar apenas assistindo.
            </p>
            <p className="text-lg">
              Você vai <strong>VIVER</strong> a experiência na prática.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {activities.map((activity, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-5 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-[#F19E1A] rounded-full flex items-center justify-center">
                    <i className={`${activity.icon} text-white text-xl`}></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-base font-bold text-gray-900 mb-1">
                    {activity.title}
                  </h3>
                  <p className="text-gray-600 text-sm">
                    {activity.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-lg text-gray-700 bg-gray-100 rounded-lg p-5 max-w-2xl mx-auto">
            Tudo em um ambiente <strong className="text-[#F19E1A]">seguro</strong> e <strong className="text-[#F19E1A]">estimulante</strong>.
          </p>
        </div>
      </div>
    </section>
  );
}
